import { Province } from '@vw-marketing/vw-ca-types';

export const getProvinceFromPostalCode = (postalCode: string) => {
  const firstChar = postalCode.charAt(0);
  switch (firstChar.toUpperCase()) {
    case "A":
      return Province.NL;
    case "B":
      return Province.NS;
    case "C":
      return Province.PE;
    case "E":
      return Province.NB;
    case "G":
    case "H":
    case "J":
      return Province.QC;
    case "K":
    case "L":
    case "M":
    case "N":
    case "P":
      return Province.ON;
    case "R":
      return Province.MB;
    case "S":
      return Province.SK;
    case "T":
      return Province.AB;
    case "V":
    case "X":
    case "Y":
      return Province.BC;
    default:
      throw new Error('Postal code not from a valid province');
  }
};
